import { Typography } from "@mui/material";
import React, { useRef, useState } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import { compose } from "underscore";
import {
  Alert,
  CampaignCard,
  DefaultLoader,
  EmptyStateSave,
  InvestedFundCard,
  MenuBar,
  NewsList,
  OverviewCard,
  GiveawayAlert,
} from "../../../components";
import { images } from "../../../constants";
import { setStatus } from "../../../utils/functions/goalCombineTrx";
import { stringDateToNumber } from "../../../utils/functions/stringDateToNumber";
import {
  getFundList,
  sendFundsCode,
  setSelectedFundCust,
} from "../../fundSelection/redux/action";
import "../../styles/index.scss"; // global styles
import styles from "../styles";

import moment from "moment";
import { showError } from "../../../globalRedux/actions";
import { calculateAgeFromYear } from "../../../utils/calculateAgeFromBirthOfYear";
import {
  injectHtmlToSpecificSentence,
  renderStyledText,
} from "../../../utils/functions/formatCampaignContent";
import { useGiveawayAlert } from "../../../utils/hooks";
import { setCustFundDetail } from "../../fundDetails/redux/action";
import {
  getMaxRetirementYear,
  getMinRetirementYear,
  getRetirementCardInfo,
  getRetirementMinAmount,
} from "../../getStarted/redux/actions";
import { getGoalSummary, getRetirementFunds } from "../../redux/action";
import { getAccountStatusV2, getRetireAnnouncement } from "../redux/actions";
import {
  RETIRE,
  GIVEAWAY_SURFACES,
  isGiveawayPromoActive,
} from "../../../utils/constants";

const liveAgentWhatsappNumber =
  process.env.REACT_APP_LIVE_AGENT_WHATSAPP_NUMBER?.trim() || "60162999792";

const Retirement = ({
  history,
  funds,
  fundsLoading,
  getGoalSummary,
  getFundList,
  retirementSummary,
  profile,
  loading,
  handleViewAllNews,
  handleCheckEcdd,
  updateActiveTab,
  campaignsRetirement = [],
  newsFeed,
  getRetirementFunds,
  retirementFunds,
  retirementMinAmount,
  getRetirementMinAmountLoading,
  // retirementProjectedReturn,
  sendFundsCode,
  showError,
  loadingCampaign,
  loadingRetirementFunds,
  getMinRetirementYear,
  getMaxRetirementYear,
  minRetirementYear,
  maxRetirementYear,
  getMinRetirementYearLoading,
  getMaxRetirementYearLoading,
  getAccountStatusV2,
  accountStatusLoading,
  getRetireAnnouncement,
  retireAnnouncementLoading,
  retireAnnouncementTitle,
  retireAnnouncementDescription,
  retireAnnouncementEndDate,
}) => {
  const [retirementWithdrawalAlert, setRetirementWithdrawalAlert] = useState(
    false
  );
  const [retirementDepositAlert, setRetirementDepositAlert] = useState(false);
  const [
    unEligibleForRetirementAgeAlert,
    setUnEligibleForRetirementAgeAlert,
  ] = useState(false);
  const { notifyGiveaway, dismissGiveaway } = useGiveawayAlert();
  const [accountStatus, setAccountStatus] = useState("empty");
  const hasCalledAccountStatus = useRef(false);

  const now = new Date().getTime();

  const retirementFund = retirementFunds[0];

  const lastTransaction = retirementFund?.lastTransactionSts[0];

  // applicable for customer that do not have prs account yet
  const lastPaymentIsProcessing =
    lastTransaction?.status === "1" && retirementFund?.lastPaymentSts === "00";

  React.useEffect(() => {
    getGoalSummary({ cifId: profile.masterId, type: "MPRetire" });
    getFundList({ category: "MPRetire" });
    getRetireAnnouncement();
    getRetirementFunds();
    getMinRetirementYear();
    getMaxRetirementYear();
    getRetirementMinAmount();
  }, []);

  React.useEffect(() => {
    if (hasCalledAccountStatus.current) return;

    if (
      retirementFund?.investmentPlan?.planId === "P11" &&
      retirementFund?.accountNo
    ) {
      getAccountStatusV2(
        { accountNo: retirementFund.accountNo, params: { type: RETIRE } },
        account => {
          if (account) {
            setAccountStatus(account.sts);
          }
          hasCalledAccountStatus.current = true;
        }
      );
    } else {
      setAccountStatus("empty");
    }
  }, [retirementFunds, hasCalledAccountStatus.current]);

  const handleDeposit = () => {
    // Guarranted exist one fund
    const { planAlias, plan, id, product, portfolio } = retirementFund;

    const planNotExistORPlanHasNoPlanFund =
      !plan ||
      (plan instanceof Object &&
        (!plan.hasOwnProperty("planFund") ||
          (plan.hasOwnProperty("planFund") && plan.planFund.length === 0)));

    const planFundHasNoFundCd =
      plan instanceof Object &&
      (plan.hasOwnProperty("planFund") &&
        plan.planFund.length > 0 &&
        plan.planFund[0] instanceof Object &&
        !plan.planFund[0].hasOwnProperty("fundCd"));

    const productNotExistORProductHasNoProductCatCdAndId =
      !product ||
      (product instanceof Object &&
        !product.hasOwnProperty("productCatCd") &&
        !product.hasOwnProperty("id"));

    const planAliasNotExistORPlanAliasHasWrongDataType =
      !planAlias || typeof planAlias !== "string";

    const idNotExistORidHasWrongDataType = !id || typeof id !== "string";

    const isPassedValidation = [
      planNotExistORPlanHasNoPlanFund,
      planFundHasNoFundCd,
      productNotExistORProductHasNoProductCatCdAndId,
      planAliasNotExistORPlanAliasHasWrongDataType,
      idNotExistORidHasWrongDataType,
    ].every(f => f === false);

    if (isPassedValidation) {
      const retireFundPlan = funds.find(fund => fund.id === product.id);

      sendFundsCode([
        {
          name: planAlias,
          //TODO hardcoded string will be change later.
          // conventional = 01
          // islamic = 02
          code: portfolio?.fund?.code
            ? portfolio?.fund?.code
            : product?.id === "MPRetireConventional"
            ? "MYU0100A1PRS"
            : "MYU0100A2PRS",
          id,

          productId: product.id,
          productCatCd: product.productCatCd,
          serviceTaxPerc: retireFundPlan.serviceTaxPerc,
        },
      ]);

      history.push("/retirement/cash-in");
      return;
    }

    const date = new Date();

    showError(
      "We are facing some technical issue, we're sorry for the inconvenience."
    );
    window.log({
      path: window.location.pathname,
      status: "400",
      res: isPassedValidation,
      req: {},
      requestDate: date,
      responseDate: date,
      responseTime: "0ms",
    });
  };

  // const handleViewAllInvestedFunds = () => {
  //   dataLayerGTM(
  //     "click_tag",
  //     "Click",
  //     "Link",
  //     "Dashboard Retiremend view all button"
  //   );
  //   history.push("/invested-retirement-funds");
  // };

  const handleTACPdf = url => {
    window.my.navigateTo({
      url: "/pages/link/link?url=" + encodeURIComponent(url),
    });
  };

  const handleInvestCashIn = () => {
    history.push("/dashboard/Invest");
    updateActiveTab(1);
  };

  const handleRetireCashIn = () => {
    const PRSNumberStatusNotActive = accountStatus.toLowerCase() !== "active";

    // not have prs and last transaction status is 3,4,9 = blocked
    // last transaction status is = 1 and last payment status is 00 = blocked
    // last transaction status other than 6 and 1 is blocked

    if (
      PRSNumberStatusNotActive &&
      lastTransaction &&
      (["3", "4", "9"].includes(lastTransaction?.status) ||
        lastPaymentIsProcessing ||
        (lastTransaction?.status !== "6" && lastTransaction?.status !== "1"))
    ) {
      return setRetirementDepositAlert(true);
    }

    return handleCheckEcdd({
      cb: handleDeposit,
      ecddExpiredCb: () => history.push("/onBoarding/ecdd/DASHBOARD"),
      gtm: {
        event: "click_tag",
        action: "Click",
        category: "Button",
        label: "Dashboard Cash In button",
      },
    })();
  };

  if (
    loading ||
    loadingRetirementFunds ||
    loadingCampaign ||
    fundsLoading ||
    getMinRetirementYearLoading ||
    getMaxRetirementYearLoading ||
    getRetirementMinAmountLoading ||
    accountStatusLoading ||
    retireAnnouncementLoading
  )
    return <DefaultLoader />;

  return (
    <>
    {/* TODO: New campaign banner sourceImage configuration */}
      {isGiveawayPromoActive(GIVEAWAY_SURFACES.RETIRE) && (
        <GiveawayAlert
          isOpen={notifyGiveaway}
          handleClose={dismissGiveaway}
          sourceImg="retireeasy2026"
        />
      )}
      <Alert
        title="Oops... You are not eligible to invest in this fund"
        description="Please contact our Customer Care Centre for assistance."
        isOpen={unEligibleForRetirementAgeAlert}
        isCancel={false}
        btnTxt="Back"
        handleAction={() => {
          setUnEligibleForRetirementAgeAlert(false);
        }}
        handleCancel={() => {
          setUnEligibleForRetirementAgeAlert(false);
        }}
        withCloseButton
        additionalContent={
          <p
            style={{
              color: "#1278CC",
              fontSize: "16px",
              fontWeight: 400,
              width: "100%",
              textAlign: "center",
              cursor: "pointer",
              display: "inline-block",
              marginBottom: "24px",
            }}
            onClick={() => {
              window.my.call("openAppLink", {
                url: `https://wa.me/${liveAgentWhatsappNumber}`,
              });
            }}
          >
            Chat with Customer Service
          </p>
        }
        submitButtonStyle={{ marginTop: "2rem" }}
      />
      {Array.isArray(retirementFunds) && retirementFunds.length > 0 ? (
        <>
          <Alert
            title="Cash Out Request"
            description="Please contact our Customer Care Center for further assistance."
            isOpen={retirementWithdrawalAlert}
            isCancel={false}
            btnTxt="Back"
            handleAction={() => {
              setRetirementWithdrawalAlert(false);
            }}
            handleCancel={() => {
              setRetirementWithdrawalAlert(false);
            }}
            withCloseButton
            additionalContent={
              <p
                style={{
                  color: "#1278CC",
                  fontSize: "16px",
                  fontWeight: 400,
                  width: "100%",
                  textAlign: "center",
                  cursor: "pointer",
                  display: "inline-block",
                  marginBottom: "24px",
                }}
                onClick={() => {
                  window.my.call("openAppLink", {
                    url: `https://wa.me/${liveAgentWhatsappNumber}`,
                  });
                }}
              >
                Chat with Customer Service
              </p>
            }
            submitButtonStyle={{ marginTop: "2rem" }}
          />
          <Alert
            title="Cash In Unsuccessful"
            description={
              lastPaymentIsProcessing
                ? "Your payment is currently in processing. Please check again on your payment status later."
                : "We could not process your request because the retirement account has not been created yet. Please try again later."
            }
            isOpen={retirementDepositAlert}
            isCancel={false}
            btnTxt="Back"
            handleAction={() => {
              setRetirementDepositAlert(false);
            }}
            handleCancel={() => {
              setRetirementDepositAlert(false);
            }}
            withCloseButton
            additionalContent={
              <p
                style={{
                  color: "#1278CC",
                  fontSize: "16px",
                  fontWeight: 400,
                  width: "100%",
                  textAlign: "center",
                  cursor: "pointer",
                  display: "inline-block",
                  marginBottom: "24px",
                }}
                onClick={() => {
                  window.my.call("openAppLink", {
                    url: `https://wa.me/${liveAgentWhatsappNumber}`,
                  });
                }}
              >
                Chat with Customer Service
              </p>
            }
            submitButtonStyle={{ marginTop: "1rem" }}
          />
          <OverviewCard
            totalAsset={retirementSummary.totalAsset}
            lastUpdate={moment(retirementSummary.lastUpdated)
              .utcOffset("+0800")
              .format("DD MMM YYYY, h:mm A")}
            type="retirement"
            riskIndex="1"
            // handleShowInvestorPopup={() => {}}
            // // //TODO Backlog (done)
            // // //TODO question: if we support more than one fund invested in retirement, how do we go about displaying this?
            // retirementFundName={retirementFund?.planAlias}
          />
          <MenuBar
            productType="retirement"
            handleWithdraw={() => {
              setRetirementWithdrawalAlert(true);
            }}
            handleDeposit={() => {
              const PRSNumberStatusNotActive =
                accountStatus.toLowerCase() !== "active";

              // not have prs and last transaction status is 3,4,9 = blocked
              // last transaction status is = 1 and last payment status is 00 = blocked
              // last transaction status other than 6 and 1 is blocked

              if (
                PRSNumberStatusNotActive &&
                lastTransaction &&
                (["3", "4", "9"].includes(lastTransaction?.status) ||
                  lastPaymentIsProcessing ||
                  (lastTransaction?.status !== "6" &&
                    lastTransaction?.status !== "1"))
              ) {
                return setRetirementDepositAlert(true);
              }

              return handleCheckEcdd({
                cb: handleDeposit,
                ecddExpiredCb: () => history.push("/onBoarding/ecdd/DASHBOARD"),
                gtm: {
                  event: "click_tag",
                  action: "Click",
                  category: "Button",
                  label: "Dashboard Cash In button",
                },
              })();
            }}
          />
          {campaignsRetirement.map((campaign, idx) =>
            now < stringDateToNumber(campaign.endDate) ? (
              <div style={{ margin: "0 1rem 1rem 1rem" }} key={idx}>
                <CampaignCard
                  startDate={campaign.startDate}
                  endDate={campaign.endDate}
                  onCashIn={handleRetireCashIn}
                  openPDF={() => handleTACPdf(campaign.extUrl)}
                  className={
                    campaign.name === "RETIREEASY"
                      ? "retireasy"
                      : "default-campaign"
                  }
                >
                  <p>
                    {renderStyledText({
                      text: campaign.desc.replace(/\s(Get)/, "\n$1"),
                      regex: /RETIRE EASY & Earn 1% Bonus|RETIREEASY/g,
                      classNames: {
                        "RETIRE EASY & Earn 1% Bonus": "retireasy__title",
                        RETIREEASY: "retireasy__code",
                      },
                    })}
                  </p>
                </CampaignCard>
              </div>
            ) : null
          )}

          {now < stringDateToNumber(retireAnnouncementEndDate) && (
            <div style={{ margin: "0 1rem 1rem 1rem" }}>
              <CampaignCard
                startDate=""
                endDate=""
                type="announcement"
                title={retireAnnouncementTitle}
              >
                {retireAnnouncementDescription}
              </CampaignCard>
            </div>
          )}

          <div
            style={{
              backgroundColor: "#fff",
              paddingTop: "1rem",
            }}
          >
            <div
              style={{
                ...styles.row,
                justifyContent: "space-between",
                margin: "0 16px 8px",
              }}
            >
              <Typography
                style={{
                  ...styles.baseFont,
                  fontWeight: "700",
                  color: "#262D58",
                }}
              >
                Invested Retirement Funds
              </Typography>
              {/* //TODO Backlog invest retirement more than one fund */}
              {/* <div
                style={{ ...styles.row }}
                onClick={handleViewAllInvestedFunds}
              >
                <Typography color="primary" style={{ ...styles.baseFont }}>
                  View all
                </Typography>
                <img src={icons.arrowRight} alt="arrowRight" />
              </div> */}
            </div>

            <div className="dashboard-funds" style={{ marginBottom: "1rem" }}>
              {setStatus(retirementFunds).map((item, idx) => (
                <InvestedFundCard
                  key={idx}
                  fundName={item.planAlias}
                  totalAsset={item.currentValue}
                  cashInStatus={item.cashInStatus}
                  unrealisedGain={item.unrealisedGain}
                  totalCost={item.totalCost}
                  handleClick={() => {
                    history.push(`/retirement/invested-funds/${item.id}/`);
                  }}
                />
              ))}
            </div>
          </div>
          {newsFeed && newsFeed.length > 0 && (
            <NewsList
              handleViewAllNews={handleViewAllNews}
              newsFeed={newsFeed}
            />
          )}
        </>
      ) : (
        <EmptyStateSave
          handleNext={handleCheckEcdd({
            cb: () => {
              const fullYear = profile.dob.split("-")[0];
              const userAge = calculateAgeFromYear(fullYear);

              const isUserNotPassedThePRSAgeRequirement =
                userAge < 19 || userAge > 53;
              const isDOBUserIsNotInRange =
                +fullYear <= +maxRetirementYear &&
                +fullYear >= +minRetirementYear;

              // 1. user not passed the age requirement
              // 2. user passed the age requirement but not passed the year of birth requirement
              // 3. user not passed the year of birth requirement

              if (
                isUserNotPassedThePRSAgeRequirement ||
                (!isUserNotPassedThePRSAgeRequirement &&
                  isDOBUserIsNotInRange) ||
                isDOBUserIsNotInRange
              ) {
                setUnEligibleForRetirementAgeAlert(true);
                return;
              }

              history.push("/retirement/fund-selection");
            },
            ecddExpiredCb: () => history.push("/onBoarding/ecdd/DASHBOARD"),
            gtm: {
              event: "click_tag",
              action: "Click",
              category: "Button",
              label: "Dashboard empty - explore retirement funds",
            },
          })}
          faqLink="https://www.principal.com.my/en/invest-va-tngewallet-faq"
          title={
            <>
              Enjoy{" "}
              <span
                style={{
                  color: "#DDF75B",
                }}
              >
                up to RM3,000*
              </span>{" "}
              tax relief!
            </>
          }
          retireDesc={
            <>
              Discover a hassle-free retirement plan with our unique Target Date
              Fund.
              <br />
              Start investing from as low as RM{retirementMinAmount}.
            </>
          }
          secondTagline={
            <>*PRS tax incentive is available until assessment year 2030.</>
          }
          actionText="Explore More"
          illustration={images.retirementIllustration}
          className="l-invest--save"
        />
      )}
    </>
  );
};

const withConnect = connect(
  state => ({
    funds: state.fundSelectionReducer.fundList,
    fundsLoading: state.fundSelectionReducer.fundListLoading,
    retirementSummary: state.goal.goalSummary,
    retirementFunds: state.goal.retirementFunds,
    loadingRetirementFunds: state.goal.loadingRetirementFunds,
    getRetirementCardInfoLoading:
      state.getStartedReducer.getRetirementCardInfoLoading,
    retirementProjectedReturn:
      state.getStartedReducer.retirementProjectedReturn,
    loadingCampaign: state.goal.loadingCampaign,
    getMaxRetirementYearLoading:
      state.getStartedReducer.getMaxRetirementYearLoading,
    getMinRetirementYearLoading:
      state.getStartedReducer.getMinRetirementYearLoading,
    maxRetirementYear: state.getStartedReducer.maxRetirementYear,
    minRetirementYear: state.getStartedReducer.minRetirementYear,
    retirementMinAmount: state.getStartedReducer.retirementMinAmount,
    getRetirementMinAmountLoading:
      state.getStartedReducer.getRetirementMinAmountLoading,
    accountStatusLoading: state.dashboardReducer.accountStatusLoading,
    retireAnnouncementLoading: state.dashboardReducer.retireAnnouncementLoading,
    retireAnnouncementTitle: state.dashboardReducer.retireAnnouncementTitle,
    retireAnnouncementDescription:
      state.dashboardReducer.retireAnnouncementDescription,
    retireAnnouncementEndDate: state.dashboardReducer.retireAnnouncementEndDate,
  }),
  {
    getGoalSummary,
    getFundList,
    setCustFundDetail,
    setSelectedFundCust,
    getRetirementFunds,
    getRetirementCardInfo,
    getRetirementMinAmount,
    sendFundsCode,
    showError,
    getMinRetirementYear,
    getMaxRetirementYear,
    getAccountStatusV2,
    getRetireAnnouncement,
  }
);

export default compose(
  withRouter,
  withConnect
)(Retirement);
